/* Layout */
import Layout from '@/views/layout/layout'
import LayoutInfo from '@/views/layout/layout-info'
import LayoutDefault from '@/views/layout/layout-default'
// import Main from '@/views/layout/app-main'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/utils/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'home' },
    component: Layout,
    children: [
      // 首页
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
          auth: true
        },
        component: _import('/system/home')
      },
      // {
      //   path: 'reportIndex',
      //   name: 'reportIndex',
      //   meta: { title: '报表' },
      //   component: _import('/report/index')
      // },

      // {
      //   path: 'my',
      //   name: 'myIndex',
      //   meta: { title: '我的' },
      //   component: _import('/platform/my/index')
      // },

      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('/system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('/system/function/redirect')
      }
    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: _import('/system/login')
  },
  {
    path: '/form-renderer-preview',
    name: 'form-renderer-preview',
    meta: {
      title: '预览',
      auth: false
    },
    component: _import('/form/formrender/preview')
  },
  {
    path: '/iframe',
    name: 'iframe',
    meta: {
      title: 'iframe'
    },
    component: _import('/system/iframe')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '/404',
    name: 'error404',
    meta: {
      title: '404-页面不存在',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/404')
  },
  {
    path: '/401',
    name: 'error401',
    meta: {
      title: '401- 未授权',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/401')
  },
  {
    path: '/403',
    name: 'error403',
    meta: {
      title: '403-权限不足',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/403')
  }
]

// 自定义
const frameCustom = [
  // {
  //   path: '/next-menu',
  //   redirect: 'index',
  //   component: LayoutInfo,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'next-menu',
  //       meta: { title: '更多', icon: 'dashboard' },
  //       component: _import('/system/dashboard/next-menu')
  //     }

  //   ]

  // },
  // {
  //   path: '/more',
  //   name: 'more',
  //   component: _import('/home/more'),
  //   meta: {
  //     title: '常用功能'
  //   }
  // },
  // {
  //   path: '/kms/kmsKnowledgeMine',
  //   name: 'kmsKnowledgeMine',
  //   component: _import('/kms/kmsKnowledgeMine'),
  //   meta: {
  //     title: '我的知识'
  //   }
  // },
  {
    path: '/message',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'message',
        meta: { title: '消息', icon: 'message' },
        component: _import('/platform/message/index')
      }
      // , {
      //   path: 'chat',
      //   name: 'chat',
      //   meta: { title: '聊天', icon: 'message' },
      //   component:_import('/message/index')
      // }
    ]
  },
  // {
  //   path: '/notice',
  //   component: Layout,
  //   redirect: 'index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'notice',
  //       meta: { title: '消息', icon: 'notice' },
  //       component: _import('/platform/notice/index')
  //     }
  //   ]
  // },
  {
    path: '/contacts',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'contacts',
        meta: { title: '应用', icon: 'contacts' },
        component: _import('/platform/contacts/index')
      }
    ]
  },
  {
    path: '/store',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'store',
        meta: { title: '门店', icon: 'contacts' },
        component: _import('/platform/contacts/appoint/storeList')
      }
    ]
  },
  {
    path: '/sign',
    name: 'sign',
    meta: {
      title: '消费单'
    },
    component: _import('/sign/sign')
  },
  {
    path: '/signature',
    name: 'signature',
    meta: {
      title: '签名'
    },
    component: _import('/sign/SignaturePanel')
  },
  {
    path: '/deduct',
    name: 'deduct',
    meta: {
      title: '服务单'
    },
    component: _import('/sign/deduct')
  },
  {
    path: '/goods',
    name: 'goods',
    meta: {
      title: '提取单'
    },
    component: _import('/sign/goods')
  },
  {
    path: '/appoint',
    component: LayoutDefault,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'appoint',
        meta: { title: '预约', icon: 'contacts', keepAlive: true },
        component: _import('/platform/contacts/appoint/form'),
      },
      {
        path: 'service',
        name: 'service',
        meta: {title: '选择项目', icon: 'contacts'},
        component: _import('/platform/contacts/appoint/serviceList')
      },
      {
        path: 'selectTime',
        name: 'selectTime',
        meta: {title: '选择预约时间', icon: 'contacts'},
        component: _import('/platform/contacts/appoint/selectTime')
      },
      {
        path: 'list',
        name: 'appointList',
        meta: { title: '预约记录', icon: 'contacts'},
        component: _import('/platform/contacts/appoint/list'),
      },
      {
        path: 'selectEmp',
        name: 'selectEmp',
        meta: {title: '选择服务人员', icon: 'contacts'},
        component: _import('/platform/contacts/appoint/empList')
      }
    ]
  },
  {
    path: '/evaluate',
    component: LayoutDefault,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'evaluate',
        meta: {title: '顾客满意度问卷', icon: 'contacts'},
        component: _import('/platform/contacts/evaluate/form'),
      }
    ]
  },
  {
    path: '/my',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'my',
        meta: { title: '我的', icon: 'my' },
        component: _import('/platform/my/index')
      },
      {
        path: 'userInfo',
        name: 'userInfo',
        meta: { title: '个人信息', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/user-info')
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        meta: { title: '修改密码', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/change-password')
      },
      {
        path: 'bindUser',
        name: 'bindUser',
        meta: { title: '正在绑定...', icon: 'my' },
        // component: _import('/platform/my/bindUserOpen/bindCp'),
        redirect: 'cp',
        component: LayoutDefault,
        children: [
          {
            path: 'cp',
            name: 'bindUserCp',
            meta: { title: '正在绑定...', icon: 'my', isLeftBar: true, isShowBar: false },
            component: _import('/platform/my/bindUserOpen/bindCp')
          },
          {
            path: 'mp',
            name: 'bindUserMp',
            meta: { title: '正在绑定...', icon: 'my', isLeftBar: true, isShowBar: false },
            component: _import('/platform/my/bindUserOpen/bindMp')
          },
          {
            path: 'ma',
            name: 'bindUserMa',
            meta: { title: '正在绑定...', icon: 'my', isLeftBar: true, isShowBar: false },
            component: _import('/platform/my/bindUserOpen/bindMa')
          }
        ]
      }
      // {
      //   path: 'setting',
      //   name: 'setting',
      //   meta: { title: '设置', icon: 'my', isLeftBar: true, isShowBar: false },
      //   component:_import('/platform/my/setting')
      // },
      // {
      //   path: 'help',
      //   name: 'help',
      //   meta: { title: '帮助', icon: 'help', isLeftBar: true, isShowBar: false },
      //   component: _import('/platform/my/help')
      // },
      // {
      //   path: 'aboutUs',
      //   name: 'aboutUs',
      //   meta: { title: '关于我们', icon: 'my', isLeftBar: true, isShowBar: false },
      //   component: _import('/platform/my/about-us')

      // },
      // {
      //   path: 'attendanceResults',
      //   name: 'attendanceResults',
      //   meta: { title: '考勤统计', icon: 'my', isLeftBar: true, isShowBar: false },
      //   component: _import('/platform/my/attendanceResults')
      // }
    ]
  },

  {
    path: '/bpmn',
    redirect: 'pending',
    component: LayoutDefault,
    children: [
      // 菜单路由
      {
        path: 'pending/index',
        name: 'pending',
        meta: { title: '待办事项' },
        component: _import('/platform/bpmn/pending/index')
      },
      {
        path: 'pending-matter/index',
        name: 'pendingMatter',
        meta: { title: '待办事项' },
        component: _import('/platform/bpmn/pending-matter/index')
      },
      {
        path: 'pending-cc/index',
        name: 'pending-cc',
        meta: { title: '抄送给我的' },
        component: _import('/platform/bpmn/pending-cc/index')
      },

      {
        path: 'kms/index',
        name: 'kms',
        meta: { title: '知识首页' },
        component: _import('/platform/bpmn/kms/index')
      },
      {
        path: 'kms/index-mine',
        name: 'kmsMine',
        component: _import('/platform/bpmn/kms/index-mine')
      },
      {
        path: 'kms/indexDtl',
        name: 'kmsDtl',
        meta: { title: '知识详情' },
        component: _import('/platform/bpmn/kms/indexDtl')
      },
      {
        path: 'kms/indexLeftDtl',
        name: 'kmsLeftDtl',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtl')
      },
      {
        path: 'kms/indexLeftDtlData',
        name: 'kmsLeftDtlData',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtlData')
      },
      {
        path: 'kms/indexLeftDtlData1',
        name: 'kmsLeftDtlData1',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtlData1')
      },
      {
        path: 'completed/index',
        name: 'completed',
        meta: { title: '办结事宜' },
        component: _import('/platform/bpmn/completed/index')
      },
      {
        path: 'handled/index',
        name: 'handled',
        meta: { title: '已办事项' },
        component: _import('/platform/bpmn/handled/index')
      },
      {
        path: 'myRequest/index',
        name: 'myRequest',
        meta: { title: '我的申请' },
        component: _import('/platform/bpmn/my-request/index')
      },
      {
        path: 'newProcess/index',
        name: 'newProcess',
        meta: { title: '发起申请' },
        component: _import('/platform/bpmn/new-process/index')
      },
      {
        path: 'myDraft/index',
        name: 'myDraft',
        meta: { title: '我的草稿' },
        component: _import('/platform/bpmn/my-draft/index')
      },
      {
        path: 'myRevoke/index',
        name: 'myRevoke',
        meta: { title: '可撤销事务' },
        component: _import('/platform/bpmn/my-revoke/index')
      },
      {
        path: 'myCompleted/index',
        name: 'myCompleted',
        meta: { title: '我结束的流程' },
        component: _import('/platform/bpmn/my-completed/index')
      },

      {
        path: 'taskChange/index',
        name: 'taskChange',
        meta: { title: '我的转办代理' },
        component: _import('/platform/bpmn/task-change/index')
      },
      {
        path: 'taskChangeDetail',
        name: 'taskChangeDetail',
        meta: { title: '详细信息' },
        component: _import('/platform/bpmn/task-change/detail')
      }
    ]
  },
  {
    path: '/bpmn',
    redirect: 'pending',
    component: LayoutDefault,
    children: [
      // 具体参数方式
      // 发起
      // http://localhost:9628/#/bpmn/form?defId=1404804933668061185
      // 待办
      // http://localhost:9628/#/bpmn/form?taskId=d9d731ac-1d0a-11ec-a113-32234a7cf847
      // 已办
      // http://localhost:9628/#/bpmn/form?instId=1441288102059388929&taskId=76eb99f0-1d00-11ec-a113-32234a7cf847
      // 草稿
      // http://localhost:9628/#/bpmn/form?defId=1579049889550635009&proInstId=1579713485058093058
      // 我的申请
      // http://localhost:9628/#/bpmn/form?instId=1579670203192061953
      // 抄送
      // http://localhost:9628/#/bpmn/form?instId=1694994991183089666&ccFlag=true

      {
        path: 'form',
        name: 'bpmnForm',
        meta: { title: '流程审批' },
        component: _import('/platform/bpmn/form/index')
      },
      // 只传taskId/instId
      // 待办/已办
      // http://localhost:9628/#/bpmn/task?taskId=5c790679-4867-11ed-8b04-ba941737fc35
      // 待办/已办/草稿/我的申请
      // http://localhost:9628/#/bpmn/task?instId=1579670203192061953
      // 抄送
      // http://localhost:9628/#/bpmn/task?instId=1694994991183089666&ccFlag=true
      {
        path: 'task',
        name: 'bpmnTask',
        meta: { title: '流程审批' },
        component: _import('/platform/bpmn/form/task/index')
      }
      // {
      //   path: '/dingtalk',
      //   redirect: 'pending',
      //   component: LayoutDefault,
      //   children: [
      //     {
      //       // 待办/已办/草稿/我的申请
      //       // http://localhost:9628/#/dingtalk/bpmn/task?instId=1579670203192061953
      //       // 待办/已办
      //       // http://localhost:9628/#/dingtalk/bpmn/task?taskId=ca086f9b-4913-11ed-8694-ba941737fc35
      //       path: 'bpmn/task',
      //       name: 'dingtalkBpmnTask',
      //       meta: { title: '流程审批' },
      //       component: _import('/platform/dingtalk/bpmn/task/index')
      //     }
      //   ]
      // }
      // {
      //   path: '/cp',
      //   redirect: 'pending',
      //   component: LayoutDefault,
      //   children: [
      //     {
      //       // 待办/已办/草稿/我的申请
      //       // http://localhost:9628/#/cp/bpmn/task?instId=1579670203192061953
      //       // 待办/已办
      //       // http://localhost:9628/#/cp/bpmn/task?taskId=ca086f9b-4913-11ed-8694-ba941737fc35
      //       path: 'bpmn/task',
      //       name: 'cpBpmnTask',
      //       meta: { title: '流程审批' },
      //       component: _import('/platform/cp/bpmn/task/index')
      //     }
      //   ]
      // },
    ]
  },
  {
    path: '/message/inner/receive',
    component: _import('/platform/message/inner/receive'),
    name: 'messageInnerReceive',
    meta: { title: '我的消息' }
  },
  {
    path: '/d/list/:id(\\w+)',
    component: _import('/platform/data/template-list'),
    name: 'dataTemplateList',
    meta: { title: '模版' }
  },
  // {
  //   path: '/d/form',
  //   component:_import('/platform/data/template-form'),
  //   name: 'dataTemplateform',
  //   meta: { title: '表单明细' }
  // },
  {
    path: '/demo',
    component: LayoutInfo,
    redirect: 'form',
    children: [
      {
        path: 'form',
        name: 'demoForm',
        meta: { title: '表单Demo', icon: 'table' },
        component: _import('/demo/form')
      }
      // {
      //   path: '1',
      //   name: 'demoForm1',
      //   meta: { title: '权限申请', icon: 'table' },
      //   component: _import('/oa/oaGemsPermission')
      // }
      //     {
      //       path: 'toolbar',
      //       name: 'demoToolbar',
      //       meta: { title: '工具栏', icon: 'toolbar' },
      //       component:_import('/demo/toolbar')
      //     }
    ]
  },
  //  http://localhost:9628/#/gateway?redirectName=bpmnTask&taskId=5e8306ed-42f5-11ee-9f46-e2ac815be2cb
  {
    path: '/gateway',
    redirect: { name: 'gatewayIndex' },
    component: LayoutDefault,
    children: [
      {
        path: 'index',
        name: 'gatewayIndex',
        component: _import('/gateway/index'),
        meta: {
          title: '加载中...',
          auth: false
        }
      },
      {
        path: 'cp',
        name: 'gatewayCp',
        component: _import('/gateway/cp'),
        meta: {
          title: '加载中...',
          auth: false
        }
      },
      {
        path: 'mp',
        name: 'gatewayMp',
        component: _import('/gateway/mp'),
        meta: {
          title: '加载中...',
          auth: false
        }
      },
      {
        path: 'ma',
        name: 'gatewayMa',
        component: _import('/gateway/ma'),
        meta: {
          title: '加载中...',
          auth: false
        }
      }
    ]
  },
  {
    path: '/tk',
    component: LayoutDefault,
    redirect: 'mdmMember',
    children: [
      {
        path: 'mdmMember',
        name: 'mdmMember',
        meta: { title: '会员登记', icon: 'table' },
        component: _import('/tk/mdmMember')
      },
      {
        path: 'mscCashRegister',
        name: 'mscCashRegister',
        meta: { title: '消费', icon: 'table' },
        component: _import('/tk/mscCashRegister')
      },
      {
        path: 'mscCashRegisterWait',
        name: 'mscCashRegisterWait',
        meta: { title: '支付等待', icon: 'table' },
        component: _import('/tk/mscCashRegisterWait')
      },
      {
        path: 'mscCashRegisterOk',
        name: 'mscCashRegisterOk',
        meta: { title: '支付成功', icon: 'table' },
        component: _import('/tk/mscCashRegisterOk')
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage,
  ...frameCustom
]
